import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, useTheme, makeStyles, Theme, createStyles } from "@material-ui/core";
import * as React from "react";
import { TemplatedText } from '../components/form/components/TemplatedText';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export interface InfoDialogOptions {
  catchOnCancel?: boolean;
  variant?: "danger" | "info" | "warning";
  title?: string;
  text?: string | string[];
  img?: string;
  content?: any;
  params?: any;
}

interface InfoDialogProps extends InfoDialogOptions {
  open: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    img: {
      maxWidth: "100%",
      width: "100%"
    }
  })
);

export const InfoDialog: React.FC<InfoDialogProps> = ({
  open,
  title,
  variant,
  text,
  img,
  params,
  onSubmit,
  onClose
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({});

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      maxWidth={'lg'}>
      { title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle> }
      <DialogContent>
        {img && <img className={classes.img} src={'/eval/images/prefetch/' + img} alt="NDFP Logo"/>}
        { Array.isArray(text) && text.map((item, i) => {
            return <DialogContentText key={i}>{item}</DialogContentText>
          })
        }
        {
          !Array.isArray(text) && text && <DialogContentText>
          <TemplatedText
            template = { text! }
            params = { params }>
          </TemplatedText>
          </DialogContentText>
        }
      </DialogContent>
      <DialogActions>
        {variant === "danger" && (
          <>
            <Button color="primary" onClick={onSubmit}>
              OK
            </Button>
            <Button color="primary" onClick={onClose} autoFocus>
              Cancel
            </Button>
          </>
        )}

        {variant === "warning" && (
          <>
            <Button color="primary" onClick={onClose} autoFocus>
              Cancel
            </Button>
            <Button color="primary" onClick={onSubmit}>
              Confirm
            </Button>
          </>
        )}

        {variant === "info" && (
          <Button color="primary" onClick={onSubmit}>
            OK
          </Button>
        )}

      </DialogActions>
    </Dialog>
  );
};
